import { useState } from 'react';
import axios from 'axios';
import { authHeaders, currentUser } from './AskKate';

const API = 'https://carriera-backend.onrender.com/api';

// Tell Kate (candidate inventory Phase 2b, 2 Nov 2026): a small button on every
// dashboard page for notes about how the dashboard or Kate's work feels. Saved
// with the page (POST /api/dashboard-feedback); Kate groups them in her Friday
// tune-up and proposes changes to Ted. Hidden for Kate's own login.
export default function TellKate({ page }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [state, setState] = useState('');   // '', 'saving', 'sent' or an error message

  if (currentUser().role === 'agent') return null;

  async function send() {
    if (!text.trim()) return;
    setState('saving');
    try {
      await axios.post(`${API}/dashboard-feedback`, { page, message: text.trim() }, { headers: authHeaders() });
      setText('');
      setState('sent');
    } catch (err) {
      setState(err.response?.data?.error || 'Failed to send the note.');
    }
  }

  return (
    <div className="fixed bottom-5 right-5 z-40">
      {open ? (
        <div className="bg-white border border-carriera-border p-4 w-80" style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.12)' }}>
          <div className="flex items-center justify-between mb-2">
            <p className="font-serif text-base text-carriera-text">Tell Kate</p>
            <button onClick={() => { setOpen(false); setState(''); }} className="text-carriera-muted hover:text-carriera-text">✕</button>
          </div>
          {state === 'sent' ? (
            <p className="text-xs text-green-700 mb-2">Thank you. Kate reads these on Fridays and suggests changes to Ted.</p>
          ) : (
            <p className="text-xs text-carriera-muted mb-2">Anything confusing, missing or wrong on this page?</p>
          )}
          <textarea rows={3} value={text} maxLength={2000} onChange={e => setText(e.target.value)}
            placeholder="e.g. Show the expected salary on the To Call list"
            className="w-full border border-carriera-border px-3 py-2 text-sm focus:outline-none focus:border-carriera-accent resize-y" />
          <div className="flex items-center gap-3 mt-2">
            <button onClick={send} disabled={state === 'saving' || !text.trim()}
              className="text-xs bg-carriera-text text-white px-4 py-1.5 hover:bg-carriera-accent transition-colors disabled:opacity-40">
              {state === 'saving' ? 'Sending...' : 'Send'}
            </button>
            {!['', 'saving', 'sent'].includes(state) && <p className="text-xs text-red-600">{state}</p>}
          </div>
        </div>
      ) : (
        <button onClick={() => setOpen(true)}
          className="text-xs bg-carriera-text text-white px-4 py-2 rounded-full hover:bg-carriera-accent transition-colors"
          style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
          Tell Kate
        </button>
      )}
    </div>
  );
}
